import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div
      className={`bg-surface rounded-lg border border-border shadow-sm ${className}`}
    >
      {children}
    </div>
  )
}

export function CardHeader({
  title,
  description,
  actions,
  className = '',
}: {
  title?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <div
      className={`flex items-start justify-between gap-4 border-b border-border px-5 py-4 ${className}`}
    >
      <div className="space-y-0.5">
        {title ? <h3 className="text-base font-semibold text-fg">{title}</h3> : null}
        {description ? (
          <p className="text-sm text-fg-muted">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  )
}

export function CardBody({
  children,
  className = '',
}: {
  children: ReactNode
  className?: string
}) {
  return <div className={`px-5 py-4 ${className}`}>{children}</div>
}

export function CardFooter({
  children,
  className = '',
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={`border-t border-border bg-surface-muted px-5 py-3 rounded-b-lg ${className}`}
    >
      {children}
    </div>
  )
}
